
import {Switch, Route} from 'react-router-dom';
import classnames from 'classnames';
import Uploader from 'components/uploader';
import Download from 'components/download';
import Manage from 'components/manage';
import FileList from 'components/file-list';
import Help from 'components/help';
import styles from './index.module.scss';


function Content({className}) {
  return (
    <main className={classnames(styles.wrapper, className)}>
      <Switch>
        <Route path="/fileList">
          <FileList />
        </Route>
        <Route path="/manage">
          <Manage />
        </Route>
        <Route path="/download">
          <Download />
        </Route>
        <Route path="/password">
          <Download isPasswordProtected />
        </Route>
        <Route path="/help">
          <Help />
        </Route>
        <Route path="/">
          <Uploader />
        </Route>
      </Switch>
    </main>
  );
}

export default Content;
